import React from 'react';
import "./Footer.css"


function Footer() {
  return (
    <footer className="footer">
      <p>&copy; 1921 Dhanno Banno Ki Rasoi. All rights reserved.</p>
      <ul className="footer-links">
        <li><a href="https://www.facebook.com/profile.php?id=100015453900888">Facebook</a></li>
        <li><a href="https://www.instagram.com/reel/Cr-w8GQpyGb/">Instagram</a></li>
        <li><a href="https://x.com/dreamgirlhema">Twitter</a></li>
      </ul>
    </footer>
  );
}

export default Footer;
